import React, { Component } from 'react';
import glamorous from 'glamorous';

const FilterSectionContainer = glamorous.div({
  borderBottom: '1px solid #443B5C',
  padding: "0 15px 15px 15px",
  marginBottom: 15
});

const FilterSectionHeader = glamorous.div({
  fontSize: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
},
({isCollapsable}) => ({cursor: isCollapsable ? 'pointer' : 'initial'})
);

const FilterSectionContent = glamorous.div({});

const CollapseButton = glamorous.span({
  fontSize: 20,
},
  ({isCollapsed}) => ({transform: isCollapsed ? 'initial' : 'rotate(45deg)'})
);


class FilterSection extends Component {
  state = {
    isCollapsed: this.props.isCollapsed || true
  }

  onCollapseClick = (e) => {
    this.setState({isCollapsed: !this.state.isCollapsed});
  }

  render() {
    const {
      children,
      header,
      isCollapsable
    } = this.props;

    return (
      <FilterSectionContainer>
        { header &&
            <FilterSectionHeader
              onClick={this.onCollapseClick}
              isCollapsable={isCollapsable}
            >
              { header }
              { isCollapsable &&
                  <CollapseButton
                    isCollapsed={this.state.isCollapsed}
                  > + </CollapseButton>
              }
            </FilterSectionHeader>
        }
        {(isCollapsable && this.state.isCollapsed) ?
            null :
            <FilterSectionContent>
              { children }
            </FilterSectionContent>
        }
      </FilterSectionContainer>
    )
  }
}

FilterSection.defaultProps = {
  isCollapsable: true
}

export default FilterSection;



// WEBPACK FOOTER //
// ./src/components/pages/Search/FilterSection.jsx